module.exports = __webpack_public_path__ + "static/img/home_img_03@3x.38f699b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main-page/home_img_03@3x.png
// module id = 86
// module chunks = 49